import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import CaretDown from "Images/profile/CaretDown.svg";
import ReactApexChart from "react-apexcharts";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import toolStyles from "../styles.module.scss";
import { useScreenWidth } from "../../SubscriptionPageV2/hooks";
import RdModule from "../RdModule";
import WarningModal from "../WarningModal";
import useRdMacroTool from "../useRdMacroTool";
import MacrosImg from "../images/macros.png";
import H3Font from "../../common/H3Font";
import CustomAccordion from "../../common/CustomAccordion";
import RegFont from "../../common/RegFont";
import Button from "../../common/Button";
import H2Font from "../../common/H2Font";
import NavBar from "../../Navigation/NavBar";
import { useSelector, useDispatch } from "react-redux";
import { setMacroResult } from "Root/profile/redux/actionCreators/makeActionCreator";
import { apiFetchMacros } from "Root/api/apiProfile";
import { MACROS_KEY } from "../../ProspreTestPage";
const carbohydrates = [
    {
        title: "Whole Grains 🌾",
        text: "Oats, quinoa, brown rice, whole wheat bread, popcorn, whole grain crackers.",
    },
    {
        title: "Fruits 🍎",
        text: "Any and all! Apples, bananas, oranges, melons, grapes, berries, melons, peaches.",
    },
    {
        title: "Vegetables 🥦",
        text: "Any and all! Broccoli, cauliflower, corn, cucumbers, celery, green beans, spinach, peas, peppers, potatoes, carrots, asparagus, zucchini, onions.",
    },
];
let protein = [
    {
        title: "Personalized Protein Powder 🥛",
        text: "Drink once a day",
    },
    {
        title: "Legumes 🫘",
        text: "Beans and lentils",
    },
    {
        title: "Animal Protein 🥩",
        text: "Chicken, turkey, fish, lean red meat, eggs and egg whites.",
    },
    {
        title: "Dairy 🧀",
        text: "Milk, yogurt, and cheese",
    },
    {
        title: "Vegan Friendly Protein 🌱",
        text: "Soy or pea milk, tofu, seitan, tempeh, edamame, peas, beans, protein powder, protein bars",
    },
];
let fat = [
    {
        title: "Nuts & Oils 🥜🥑",
        text: "Nuts, seeds, nut or seed butters, dairy, avocados, fatty fish, plant oils, hummus.",
    },
];
const ResultPage = () => {
    const dispatch = useDispatch();
    const macroResult = useSelector((state) => state.dietitian.macroResult);
    const { open, handleClose, goToRd, setShowModal, user, faqs, goToMacroInput, profileData } = useRdMacroTool();
    const [settings, setSettings] = useState({
        series: [0, 0, 0],
        options: {
            labels: ["Carbs", "Protein", "Fat"],
            colors: ["#F48782", "#B6CEAE", "#93A7CB"],
            plotOptions: {
                pie: {
                    dataLabels: {
                        offset: -30,
                    },
                },
            },
            dataLabels: {
                enabled: true,
                style: {
                    fontWeight: "400",
                    fontFamily: "Rhode, sans-serif",
                    fontSize: "12px",
                    colors: ["#000"],
                },
                dropShadow: {
                    enabled: false,
                },
                offsetX: -10,
            },
            stroke: {
                colors: ["#f6f3eb"],
            },
        },
    });
    if (profileData.dietary.includes("Vegan") || profileData.dietary.includes("Vegetarian")) {
        protein = protein.slice(0, 2).concat(protein.slice(-1));
        fat[0].text = "Nuts, seeds, nut or seed butters, avocados, plant oils, hummus.";
    }
    else {
        protein = protein.slice(0, 4);
    }
    const fetchMacroResults = async () => {
        const response = await apiFetchMacros();
        dispatch(setMacroResult(response));
    };
    useEffect(() => {
        const s = macroResult;
        const newVals = {
            calories: s.calories,
            gramsCarbs: s.carbs,
            gramsFat: s.fat,
            gramsProtein: s.protein,
            percCarbs: Math.floor(s.carb_percent * 100),
            percFat: Math.floor(s.fat_percent * 100),
            percProtein: Math.floor(s.protein_percent * 100),
        };
        if (macroResult.calories) {
            localStorage.setItem(MACROS_KEY, JSON.stringify(newVals));
        }
    }, [macroResult.calories]);
    useEffect(() => {
        if (macroResult) {
            setSettings({
                ...settings,
                series: [
                    Number((macroResult.carb_percent * 100).toFixed(0)),
                    Number((macroResult.protein_percent * 100).toFixed(0)),
                    Number((macroResult.fat_percent * 100).toFixed(0)),
                ],
            });
        }
        else {
            fetchMacroResults();
        }
    }, [macroResult]);
    const macros = [
        {
            title: "Calories",
            value: `${macroResult?.calories.toFixed(0)} calories per day`,
            percent: "",
        },
        {
            title: "CARBOHYDRATES",
            value: `${Math.abs(macroResult?.carbs_range[0])}-${Math.abs(macroResult?.carbs_range[1])} grams per day`,
            percent: `${Number((macroResult?.carb_percent * 100).toFixed(0))}%`,
        },
        {
            title: "protein",
            value: `${Math.abs(macroResult?.protein_range[0])}-${Math.abs(macroResult?.protein_range[1])} grams per day`,
            percent: `${Number((macroResult?.protein_percent * 100).toFixed(0))}%`,
        },
        {
            title: "fat",
            value: `${Math.abs(macroResult?.fat_range[0])}-${Math.abs(macroResult?.fat_range[1])} grams per day`,
            percent: `${Number((macroResult?.fat_percent * 100).toFixed(0))}%`,
        },
    ];
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth < 900;
    const getChartWidth = () => {
        if (screenWidth < 360) {
            return 260;
        }
        else if (screenWidth < 768) {
            return 360;
        }
        return 400;
    };
    useEffect(() => {
        if (macroResult?.low_bmi_alert) {
            setShowModal(true);
        }
    }, [macroResult]);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(NavBar, { userName: user.full_name, showTop: !!user.full_name, userLoggedIn: !!user.full_name }), macroResult && (_jsxs("div", { className: styles.result_page, children: [_jsx(WarningModal, { open: open, handleClose: handleClose, onClick: goToRd }), _jsxs("div", { className: toolStyles.title_wrapper, children: [_jsx("button", { type: "button", className: toolStyles.back, onClick: goToMacroInput, children: _jsx("img", { src: CaretDown, alt: "" }) }), _jsxs(H2Font, { children: ["Your", isMobile && _jsx("br", {}), " Macronutrients"] }), _jsx("div", { className: toolStyles.empty })] }), _jsxs("div", { className: styles.macros_wrapper, children: [_jsx("div", { className: styles.macros, children: macros.map((item) => (_jsxs("div", { className: styles.macro_item, children: [_jsx("span", { className: styles.title, children: item.title }), _jsx("div", { className: styles.value, children: _jsx("span", { children: item.value }) })] }, item.title))) }), _jsx("div", { className: styles.note, children: "**This macrocalculator gives you an estimated calorie goal based on the Mifflin St Jeor Equation and your\u00A0 provided values." })] }), _jsxs("div", { className: styles.what_are_macro, children: [_jsxs("div", { className: styles.text, children: [_jsx(H3Font, { className: styles.title, fontWeight: 400, children: "What are macronutrients?" }), _jsx("div", { className: styles.copy, children: "Macronutrients are the components within food that provide us with energy in the form of calories. Usually when discussing macronutrients, we are referring to the total amount and distribution of carbs, protein, and fat within your diet. Paying attention to macronutrient intake can be a beneficial way to make sure that your diet consists of an optimal amount of each for the goals that you have." })] }), _jsx("div", { className: styles.img, children: _jsx("img", { src: MacrosImg, alt: "" }) })] }), _jsxs("div", { className: styles.what_are_calories, children: [_jsx(H3Font, { fontWeight: 400, className: styles.title, children: "What are calories, really?" }), _jsx("div", { className: styles.copy, children: "Calories are the energy that our bodies need and use to exercise, move around in our day, and perform autonomic functions like breathing and digestion. Each body needs a certain amount of calories on average, and that number is influenced by factors such as your activity level, height, weight, age, and gender." }), _jsxs("div", { className: styles.to_reach, children: [_jsx(H3Font, { fontWeight: 400, className: styles.title, children: "To reach your goal" }), _jsx("hr", {}), macroResult.goal === "lose weight" ? (_jsxs("div", { className: styles.copy, children: ["In order to lose weight and body fat, you'll need to be in a moderate and consistent calorie deficit.\u00A0 Based on your info, we estimate that your body needs around\u00A0", macroResult.maintenance_calories.toFixed(), " calories per day to maintain your current weight. In order to\u00A0 promote a deficit, try for a calorie target around\u00A0", macroResult.calories.toFixed(), " for sustainable deficit."] })) : (_jsx(_Fragment, { children: macroResult.goal === "gain weight" ? (_jsxs("div", { className: styles.copy, children: ["In order to gain weight, you\u2019ll need to maintain a small calorie surplus over time.\u00A0 Based on your info, we estimated that you need about\u00A0", macroResult.maintenance_calories.toFixed(), " calories per day in order to maintain your weight.\u00A0 To promote a small surplus, try for\u00A0", macroResult.calories.toFixed(), " on a regular basis."] })) : (_jsxs("div", { className: styles.copy, children: ["Based on your info, we estimated that your body needs\u00A0", macroResult.calories.toFixed(), " calories on a daily basis to sustain your current weight.\u00A0 Aim to consume around that many on average over time."] })) }))] }), _jsxs("div", { children: [_jsx("span", { className: styles.breakdowntitle, children: "Example Macro Breakdown" }), _jsx("hr", {}), _jsx(RegFont, { children: "Below is a pie chart showing an example of what the percentage breakdown of your recommended macros could look like based on the midpoint of your daily macro ranges." }), _jsx("div", { className: styles.chart, children: _jsx(ReactApexChart, { options: settings.options, series: settings.series, type: "pie", width: getChartWidth() }) })] }), _jsxs("div", { className: styles.to_reach, children: [_jsxs("div", { className: styles.title_wrapper, children: [_jsx(RegFont, { fontWeight: 400, className: styles.title, children: "Carbohydrates" }), _jsxs("span", { className: styles.rhode_percent, children: [Number((macroResult.carb_percent * 100).toFixed(0)), "%"] })] }), _jsx("hr", {}), _jsx("div", { className: styles.copy, children: carbohydrates.map((item) => (_jsxs("div", { className: styles.carbo_item, children: [_jsx(RegFont, { fontWeight: 400, children: item.title }), _jsx(RegFont, { children: item.text })] }, item.title))) }), _jsxs("div", { className: styles.title_wrapper, children: [_jsx(RegFont, { fontWeight: 400, className: styles.title, children: "Protein" }), _jsxs("span", { className: styles.rhode_percent, children: [Number((macroResult.protein_percent * 100).toFixed(0)), "%"] })] }), _jsx("hr", {}), _jsx("div", { className: styles.copy, children: protein.map((item) => (_jsxs("div", { className: styles.carbo_item, children: [_jsx(RegFont, { fontWeight: 400, children: item.title }), _jsx(RegFont, { children: item.text })] }, item.title))) }), _jsxs("div", { className: styles.title_wrapper, children: [_jsx(RegFont, { fontWeight: 400, className: styles.title, children: "Fat" }), _jsxs("span", { className: styles.rhode_percent, children: [Number((macroResult.fat_percent * 100).toFixed(0)), "%"] })] }), _jsx("hr", {}), _jsx("div", { className: styles.copy, children: fat.map((item) => (_jsxs("div", { className: styles.carbo_item, children: [_jsx(RegFont, { fontWeight: 400, children: item.title }), _jsx(RegFont, { children: item.text })] }, item.title))) })] }), _jsx("div", { className: styles.btn, children: _jsx(Button, { onClick: goToMacroInput, color: "court", children: "Recalculate" }) }), user.full_name && _jsx(RdModule, {})] }), _jsxs("div", { className: styles.faq, children: [_jsx(H2Font, { fontWeight: 400, children: "FAQ" }), _jsx("div", { className: styles.faq_item, children: faqs.map((item) => (_jsx(CustomAccordion, { title: item.title, children: _jsx(RegFont, { children: item.text }) }, item.text))) })] })] }))] }));
};
export default ResultPage;
